'use strict';

const $ = require('dibs-jquery-shim');
const animationFrame = require('global/utils/requestAnimationFrame');
var Set = require('babel-runtime/core-js/set').default;

// Keep track of currently transitioning elements here so we don't duplicate transitions.
const transitioningElements = new Set();

/**
 * Helper function for adding CSS transitions to elements. Pass in the element to transition and optional start and
 * end callbacks. The endCallback will fire when the transition has completed. To use this helper. Give your element
 * `transition-start` and `transition-active` classes. `transition-start` is added first and `transition-active` is
 * added on the next tick.
 *
 * @example
 * // This setup wil cause the element to transition from opacity 0 to 1 over 250ms.
 * .my-element {
 *     &.transition-start {
 *         opacity: 0;
 *
 *         &.transition-active {
 *             @include transition(opacity 250ms linear);
 *             opacity: 1;
 *         }
 *     }
 * }
 *
 * @param  {object} $el            JQuery object of the element you wish to transition.
 * @param  {function} [options.startCallback] Callback to fire at the beginning of the transition.
 * @param  {function} [options.endCallback] Callback to fire at the end of the transition.
 */
function transitionElement($el, { startCallback, endCallback } = {}) {
    let timer;

    if (!$el instanceof $) {
        throw new Error('Passed in element must be a JQuery object.');
    }

    if (transitioningElements.has($el)) {
        return;
    }

    // Need to add this callback on the children of the element or else transitions on the children can cut the main
    // transition short.
    const childCallback = () => false;
    transitioningElements.add($el);

    if (typeof startCallback === 'function') {
        startCallback();
    }

    $el
        .one('transitionend', () => {
            $el.removeClass('transition-start transition-active');
            $el.children().off('transitionend', childCallback);

            if (typeof endCallback === 'function') {
                endCallback();
            }

            transitioningElements.delete($el);

            clearTimeout(timer);
        })
        .children()
        .on('transitionend', childCallback);

    $el.addClass('transition-start');

    // Add the second class on the next tick so the first class has a change to register.
    animationFrame(() => {
        $el.addClass('transition-active');

        // The transitionend event doesn't fire reliably in some browsers. This timeout will fire in case transitionend
        // fails and will get cleared if it succeeds.
        timer = setTimeout(() => {
            $el.trigger('transitionend');
        }, 500);
    });
}

module.exports = {
    transitionElement,
};



// WEBPACK FOOTER //
// ./assets/js/global/utils/transitionHelpers.es.js